// src/lib/cache/payments.js
//
// Per-entity cache wiring for payments. No deferredField — payments have no
// server-fabricated number; id/timestamps are overwritten cleanly by
// reconcile.

import {
  getPayments,
  createPayment,
  updatePayment,
  deletePayment,
} from '../api/financial/payments.js'
import {
  useEntityListQuery,
  useOptimisticListMutation,
  useStandardDeleteMutation,
  defaultCreateReconcile,
  defaultUpdateReconcile,
  unwrapList,
} from './entityCache.js'

const ENTITY = 'payments'

const buildCreatePlaceholder = (vars, tempId) => {
  const now = new Date().toISOString()
  return {
    status: 'completed',
    ...vars,
    id: tempId,
    created_at: now,
    updated_at: now,
  }
}

export const usePaymentsQuery = () =>
  useEntityListQuery(ENTITY, unwrapList('payments', getPayments))

export const useCreatePaymentMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: (paymentData) => createPayment(paymentData),
    applyOptimistic: (prev, vars, { tempId }) => [
      buildCreatePlaceholder(vars, tempId),
      ...prev,
    ],
    reconcile: defaultCreateReconcile,
  })

export const useUpdatePaymentMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: ({ id, ...patch }) => updatePayment(id, patch),
    applyOptimistic: (prev, vars) =>
      prev.map((row) => (row.id === vars.id ? { ...row, ...vars } : row)),
    reconcile: defaultUpdateReconcile,
  })

export const useDeletePaymentMutation = () =>
  useStandardDeleteMutation(ENTITY, deletePayment)
